import type { MockRatingTarget } from '@/lib/catalog/mock-user-score'

/** Maps mock compare response ids to catalog models for score E2E. */
export const MOCK_COMPARE_RATING_TARGETS: Record<string, MockRatingTarget> = {
  'resp-gpt4o': { modelId: 'model-rated-demo', categoryId: 'cat-coding' },
}
